import apiService from '../../../services/api-client';
import { PostLoginRequest, PostLoginResponse } from '../interfaces/post-login';
import {
  PostRefreshRequest,
  PostRefreshResponse,
} from '../interfaces/post-refresh';

export const authApiService = {
  async postLogin(body: PostLoginRequest) {
    const { data } = await apiService().post<PostLoginResponse>(
      `auth/login`,
      body
    );
    return data;
  },
  async postRefresh(body: PostRefreshRequest) {
    const { data } = await apiService().post<PostRefreshResponse>(
      `auth/refresh`,
      body
    );
    return data;
  },
};
